// src/Common/PageHeader.jsx
import React from "react";

const PageHeader = ({ 
  title, 
  description, 
  breadcrumbs = [], 
  actionButton = null 
}) => {
  return (
    <div className="mb-5 flex flex-col lg:flex-row lg:items-end justify-between gap-4">
      <div>
        {breadcrumbs.length > 0 && (
          <nav className="flex items-center gap-2 text-[11px] font-bold text-on-surface-variant mb-2 uppercase tracking-wider">
            {breadcrumbs.map((item, index) => (
              <React.Fragment key={index}>
                <span 
                  className={item.onClick ? "hover:text-primary cursor-pointer" : "text-on-surface"}
                  onClick={item.onClick}
                >
                  {item.label}
                </span>
                {index < breadcrumbs.length - 1 && (
                  <span className="material-symbols-outlined text-[14px]">chevron_right</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
        <h1 className="text-2xl font-black text-on-surface tracking-tight">{title}</h1>
        <p className="text-on-surface-variant mt-1 max-w-2xl text-sm leading-relaxed">
          {description}
        </p>
      </div>
      {actionButton && (
        <div className="flex items-center gap-3">
          {actionButton}
        </div>
      )}
    </div>
  );
};

export default PageHeader;